import { mapOptions } from '@/modules/defines/datas';

const normalizationZoneState = (floor: string, type: string) => {
  if (floor === '-2') {
    return mapOptions[5].id;
  }
  if (floor === '-3') {
    return mapOptions[6].id;
  }
  if (floor === '-1') {
    return mapOptions[4].id;
  }
  if (floor === '1') {
    if (type === 'raon') {
      return mapOptions[2].id;
    } else if (type === 'atti') {
      return mapOptions[3].id;
    }
  }
  if (floor === '2') {
    if (type === 'raon') {
      return mapOptions[0].id;
    } else if (type === 'atti') {
      return mapOptions[1].id;
    }
  }
  return mapOptions[4].id; //default
};

export default normalizationZoneState;
